import 'element-closest-polyfill';
import 'intersection-observer';
// @ts-ignore
import * as objectFitImages from 'object-fit-images';

export class Polyfills
{
    constructor() {
        objectFitImages();
    }
}
